var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"support submain-div"},[_c('h1',{staticClass:"global-title"},[_vm._v(" 支持和常见问题 ")]),_c('div',[_c('h3',[_vm._v(" 餐饮标准版跟进阶版有什么区别 ")]),_c('p',[_vm._v(" 主要区别就是标准版只能一台电脑运行,而进阶版可以手机和平板点单,支持多设备连接. 进阶版的硬件性能也比标准版提高. ")]),_c('h3',[_vm._v(" 冷默餐饮系统跟奇思有什么区别 ")]),_c('p',[_vm._v(" 都是一样的，冷默是我之前测试的名字，刚开始起步 使用这个名字， 现在开始使用正式，并改名为 奇思科技 ")])]),_c('p')])
}]

export { render, staticRenderFns }